import React from 'react';
import { translate } from 'react-i18next';
import Cropper from 'react-cropper';
import { Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';

import {colors} from 'style';
import styleDef from './style.js';

var style= {
    ...styleDef,
    containerDiv: {
        height:'100%', 
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    photo:{
        width: 'auto',
        height:'15em'
    },
    video:{
        width: '15em',
        height:'15em'
    },
    column:{
        width: '20em'
    },
    videoContainer: {
        position: 'relative',
        display: 'inline-block',
        minHeight: '150px'
    },
    cameraButtonContainer: {
        position: 'absolute',
        left: '50%',
        bottom: '5px'
    },
    cameraButton: {
        position: 'relative',
        left: '-50%',
        margin: '0'
    },
};

const Photo = ({t,
                challenge, 
                photo,
                buttonText,
                croppedPhoto,
                setCropper,
                setVideo,
                setCanvas,
                onCrop,
                onCropperReady,
                supportsVideoCapture,
                onCapturePhoto,
                error, 
                onComplete}) => (
    <Container style={style.container}>
        <div style={style.containerDiv}>
        <Segment style={style.segment}>
            <Grid style={style.grid} centered>
                <Grid.Row verticalAlign='top' style={style.topRow}>
                    <Grid.Column verticalAlign='top'>
                        <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                    </Grid.Column>
                </Grid.Row>
              
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='middle'>
                        <Instructions challenge={challenge} />
                    </Grid.Column>
                </Grid.Row>
                {!error && supportsVideoCapture &&
                <Grid.Row verticalAlign='middle'>
                        <Grid.Column style={style.column}>
                            <Header>{t('Camera:')}</Header>
                            <span style={style.videoContainer}>
                                <video style={style.video} ref={setVideo} id="video" width="1024" height="1024" autoPlay></video>
                                <div style={style.cameraButtonContainer}>
                                    <Button size="small" circular color='teal' icon="camera" onClick={onCapturePhoto} style={style.cameraButton}></Button>
                                </div>
                            </span>
                            <canvas ref={setCanvas} id="canvas" width="1024" height="1024" style={{display:'none'}}></canvas>
                        </Grid.Column>
                        <Grid.Column style={style.column}>
                            <Header>{t('Crop Photo:')}</Header>
                            {photo &&
                                <Cropper ref={setCropper} src={photo} style={style.photo} aspectRatio={1} guides={false} zoomable={false} rotatable={false} dragMode='none' responsive={true} autoCrop={true} cropend={onCrop} ready={onCropperReady} viewMode={2}  />
                            }
                        {!photo &&
                        <div style={{...style.photo, width:'15em', backgroundColor:'grey'}}></div>
                        }
                        </Grid.Column>
                        <Grid.Column style={style.column}>
                            <Header>{t('Result Photo:')}</Header>
                            {croppedPhoto &&
                            <img src={croppedPhoto} style={style.photo} />
                            }
                            {!croppedPhoto &&
                            <div style={{...style.photo, width:'15em', backgroundColor:'grey'}}></div>
                            }
                        </Grid.Column>
                </Grid.Row>
                }
                <Grid.Row verticalAlign='bottom'>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        {!error && !supportsVideoCapture &&
                            <Message negative>{t('Camera access not supported')}</Message>
                        }
                        {error &&
                            <Message negative>
                                <Message.Header>{t('Error')}</Message.Header>
                                <p>{error}</p>
                            </Message>
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>
        <div style={{...style.button, ...(croppedPhoto ? {} : style.buttonDisabled)}} onClick={onComplete}>{buttonText}</div>
    </div>
    </Container>
);

export default translate('challenges')(Photo);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/Photo.js